// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.tooltip {
  height: 16px !important;
  width: 16px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.tooltip.MuiSvgIcon-root {
  color: #999999;
  width: 1.125rem;
  display: flex;
  margin-top: 3px;
}

.infoTextIcon {
  cursor: pointer;
  pointer-events: all;
  margin-top: 2px;
}
.MuiTooltip-arrow {
  display: none !important;
}
.MuiTooltip-popper[data-popper-placement*='right'] .MuiTooltip-tooltip {
  padding: 8px;
  background-color: var(--tooltipBackgroundColor);
}
.LongText {
  font-size: 13px;
  font-weight: 400;
  font-family: var(--default-FontName);
  color: var(--tooltipFontColor) !important;
}
`, "",{"version":3,"sources":["webpack://./src/views/components/base/infoText/InfoText.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,+CAA+C;AACjD;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,yCAAyC;AAC3C","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.tooltip {\n  height: 16px !important;\n  width: 16px !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.tooltip.MuiSvgIcon-root {\n  color: #999999;\n  width: 1.125rem;\n  display: flex;\n  margin-top: 3px;\n}\n\n.infoTextIcon {\n  cursor: pointer;\n  pointer-events: all;\n  margin-top: 2px;\n}\n.MuiTooltip-arrow {\n  display: none !important;\n}\n.MuiTooltip-popper[data-popper-placement*='right'] .MuiTooltip-tooltip {\n  padding: 8px;\n  background-color: var(--tooltipBackgroundColor);\n}\n.LongText {\n  font-size: 13px;\n  font-weight: 400;\n  font-family: var(--default-FontName);\n  color: var(--tooltipFontColor) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
